module.exports = "<div class=\"container\">\n  <form>\n    <label>导入数据</label>\n    <div class=\"form-group\">\n      <label for=\"file\" class=\"text-danger\">文件 <span>(必需, 支持格式xlsx,xls,txt)</span></label>\n      <input type=\"file\" ngf-select ng-model=\"betagroupsImportCtrl.file\" name=\"file\" required ngf-model-invalid=\"errorFile\" class=\"form-control\">\n    </div>\n\n    <button type=\"submit\" class=\"btn btn-success\" ng-click=\"betagroupsImportCtrl.upload(betagroupsImportCtrl.file)\">保存</button>\n  </form>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/betagroups/import/import.html
// module id = 301
// module chunks = 0